import { GeoAddressRequest } from "../geo-addresses";
import { Duration } from "luxon";
import { JobLocation } from "./job-locations-request";

export interface AddEditJobRequest  {
  Id: string;
  jobNumber: string;
  jobName: string;
  vehicleType:number;
  startAddress: string;
  endAddress: string;
  startTerminalName: string;
  endTerminalName: string;
  startTime: string;
  endTime: string;
  estimatedStartTime: string;
  estimatedEndTime: string;
  jobTemplate:string;
  startGeoAddress: GeoAddressRequest;
  endGeoAddress: GeoAddressRequest;
  duration: Duration;
  distance: number;
  planId: string;
  capacityType1?: number;
  capacityType2?: number;
  capacityType3?: number;
  qualifications: string;
  locationsCount?: number;
  createdAt: string;
  locations? : JobLocation[];
  connectionId : string;
  distributionAreaId?: string;
  distributionAreaName?: string;
  jobIds? : (string| undefined)[]; 
  startTerminalCity: string;
  startTerminalPostalCode: string;
  endTerminalCity: string;
  endTerminalPostalCode: string;

}
